<template>
  <div class="container">
    <div class="header-box">
      <home-top></home-top>
    </div>
    <div class="content-box">
      <!-- 轮播图 -->
      <div class="content-swiper">
        <swiper class="sAstyle" :swiperSetting="swiperSetting" :slideArray="slideArray"></swiper>
        <!-- 遮罩层 -->
        <div class="rotationMask">
          <span>{{ rotationFont }}</span>
        </div>
      </div>
      <!-- 主体 -->
      <div class="bodyContent">
        <!-- 公司宣传片 -->
        <!-- <div class="companyPromotional">
          <img src="../assets/promotional.png" class="p-imgStyle" />
        </div> -->
        <!-- 公司介绍 -->
        <div class="corproateCulture">
          <!-- 文字 -->
          <div class="corproateFrame">
            <div class="corproateFont">
              <div class="corproateChildFont">
                <span>{{ company }}</span>
              </div>
              <div class="corproateChildFont1">
                <span>{{ companyEnglish }}</span>
              </div>
            </div>
            <div class="corproateDuction">
              <p>{{ briefIntroduction }}</p>
            </div>
          </div>
          <!-- 图片 -->
          <div class="corproateFrame1">
            <img src="../assets/gongsi.png" class="frameImg" />
          </div>
        </div>
        <!-- 企业组织架构 -->
        <div class="enterpriseOrgan">
          <!-- 标题 -->
          <div class="developmentTop">
            <div class="developmentTopFrame"></div>
            <div class="developmentTopFont">
              <div class="developmentFontChild">
                <span>企业组织架构</span>
              </div>
              <div>
                <span>ENTERPRISE ORGANIZATIONAL STRUCTURE</span>
              </div>
            </div>
            <div class="developmentTopFrame"></div>
          </div>
          <div class="enterpriseOrganContent">
            <div class="enterpriseOrganContentImgFrame">
              <img src="../assets/mindMap.jpg" class="p-imgStyle" />
            </div>
          </div>
        </div>
        <!-- 企业发展历程 -->
        <div class="development">
          <!-- 标题 -->
          <div class="developmentTop">
            <div class="developmentTopFrame"></div>
            <div class="developmentTopFont">
              <div class="developmentFontChild">
                <span>企业发展历程</span>
              </div>
              <div class="developmentFontChild1">
                <span>ENTERPRISE DEVELOPMENT HISTORY</span>
              </div>
            </div>
            <div class="developmentTopFrame"></div>
          </div>
          <!-- 内容 -->
          <div class="developmentContent">
            <div class="developmentContentChild">
              <div class="developmentFrame" v-for="(item, index) in developArray" :key="index">
                <div class="developmentFrameImg">
                  <img :src="item.url" class="p-imgStyle" />
                </div>
                <div class="developmentFrameYear">
                  <span>{{ item.year }}年</span>
                </div>
                <div class="developmentFrameContent">
                  <span>{{ item.content }}</span>
                </div>
              </div>
            </div>
            <!-- 插入 -->
            <div class="insertFrame">
              <div class="insertChildFrame">
              </div>
              <div class="circleGroup">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
            </div>
            <!-- 文字 -->
            <div class="propaganda">
              <div class="propagandaChild">
                <div class="propagandaChild1">
                  <span>未来</span>
                </div>
                <div class="propagandaChild2">
                  <span>我们将不断前行</span>
                </div>
                <div class="propagandaChild3">
                  <span>不断挑战</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 企业文化 -->
        <div class="corporateCulture">
          <!-- 标题 -->
          <div class="developmentTop">
            <div class="developmentTopFrame"></div>
            <div class="developmentTopFont">
              <div class="developmentFontChild">
                <span>企业文化</span>
              </div>
              <div>
                <span>CORPORATE CULTURE</span>
              </div>
            </div>
            <div class="developmentTopFrame"></div>
          </div>
          <!-- 内容 -->
          <div class="cultureContent">
            <div class="cultureContentFrame">
              <img src="../assets/culture.png" class="imgStyle" />
            </div>
            <div class="cultureContent1">
              <div class="cultureContent1ChildFrame">
                <img src="../assets/culture1.png" class="imgStyle" />
              </div>
              <div class="cultureContent1Child"></div>
            </div>
            <div class="enterpriseVision">
              <div>
                <span>企业愿景</span>
              </div>
              <div class="p-marginTop10">
                <span>引领新消费、新经济、新业态; 让中国新经济产业走向世界</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 企业资质 -->
        <div class="enterpriseQua">
          <div class="developmentTop">
            <div class="developmentTopFrame"></div>
            <div class="developmentTopFont">
              <div class="developmentFontChild">
                <span>企业资质</span>
              </div>
              <div>
                <span>ENTERPRISE QUALIFICATION</span>
              </div>
            </div>
            <div class="developmentTopFrame"></div>
          </div>
          <div class="enterpriseQuaContent">
            <div class="enterpriseQuaContentFrame">
              <!-- 1 -->
              <div class="enterpriseQuaContentChild">
                <div class="enterpriseQuaContentFont">
                  <div class="enterpriseFontChild">
                    <span>社会责任</span>
                  </div>
                  <div class="enterpriseFontChild1">
                    <span>Social responsibility</span>
                  </div>
                </div>
                <div class="enterpriseImg">
                  <img src="../assets/active.png" class="p-imgStyle" />
                </div>
              </div>
              <!-- 2 -->
              <div class="enterpriseQuaContentChild1">
                <div class="enterpriseQuaContentFont">
                  <div class="enterpriseFontChild">
                    <span>政府关怀</span>
                  </div>
                  <div class="enterpriseFontChild1">
                    <span>Government care</span>
                  </div>
                </div>
                <div class="enterpriseQuaContentChild1Frame">
                  <div class="enterpriseQuaContentChild1Img">
                    <div class="enterpriseQuaChildImg1">
                      <img src="../assets/qualifications1.png" class="p-imgStyle" />
                    </div>
                    <div class="enterpriseQuaChildImg2">
                      <img src="../assets/qualifications2.png" class="p-imgStyle" />
                    </div>
                  </div>
                  <div class="enterpriseQuaChild1Bg">
                    <span>{{ GovernmentCareFont }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-box">
      <home-bottom></home-bottom>
    </div>
  </div>
</template>

<script>
import swiper from "../assembly/swiper.vue"
import homeTop from '../assembly/homeTop.vue'
import homeBottom from '../assembly/homeBottom.vue'
import imgAndText from "../common/imgAndText"
export default {
  data() {
    return {
      swiperSetting: {
        delay: 3000
      },
      slideArray: [
        { url: require("@/assets/bg1.png") }, 
      ],
      rotationFont: "公司公告: 山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名",
      company: "山哩数智科技有限公司",
      companyEnglish: "SHANLI RECHNOLOGY HOLDING CO.LTD",
      briefIntroduction: `山哩科技以新消费和智慧供应链行业营销为基础, 依托互联网大数据应用技术 , 结合自身拥有的全国零售和消费品行业 '产、 供、 销、服务一体化供应链', 整合B端产业集群和C端消费集群, 打造 'OMO( 线上分享、线下集散 ) +B2B ( 企业到企业 ) + O2F2C( 订单农业、以销定产 ) 模式 '`,
      developArray: [
        { url: require("@/assets/deve1.png"), year: "2013", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目以京东合伙人, 阿里生鲜、京东生鲜供应商的形式落地贵州毕节黔西。" },
        { url: require("@/assets/deve2.png"), year: "2014", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0京东生鲜正式纳入贵州项目, 正式启动京东黔西县特产馆。" },
        { url: require("@/assets/deve3.png"), year: "2015", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0项目成功获得西南地区阿里、京东生鲜的唯一供应商。" },
        { url: require('@/assets/deve4.png'), year: "2016", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0正式与黔西县人民政府签署战略合作, 成立好农哥生态农业有限公司" },
        { url: require('@/assets/deve5.png'), year: "2017", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名" },
        { url: require('@/assets/deve6.png'), year: "2018", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa02018年7月山哩优品电商品牌正式与京东脱离" },
        { url: require('@/assets/deve7.png'), year: "2019", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0独立运营, 寻求合作伙伴, 以最佳的现货交易模式做全国顶尖的订单农业电商品牌" },
        { url: require('@/assets/deve8.png'), year: "2020", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0通过VIE架构在美国纳斯达克上市。山哩成为该年度以SPAC主板上市企业" },
        { url: require('@/assets/deve9.png'), year: "2021", content: "\xa0\xa0\xa0\xa0\xa0\xa0\xa0完成了A轮的3亿元人民币融资, 开启了向纳斯达克主板上市之路" }
      ],
      GovernmentCareFont: "山哩科技的快速成长, 离不开党和国家的各项优惠政策, 更离不开各级政府领导的亲切关怀。公司成立以来各级政府领导多次对公司进行业务指导, 并对山哩科技的发展给予高度的肯定和赞赏, 鼓舞着山哩人乘风破浪勇往直前",
      abc: ""
    }
  },
  components: {
    homeTop,
    swiper,
    homeBottom,
    imgAndText
  }
}
</script>


<style scoped lang="scss">
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.header-box {
  height: 85px;
  width: 100%;
}

.content-box {
  box-sizing: border-box;
  width: 100%;

  .content-swiper {
    height: 92vh;
    width: 100%;

    // 遮罩层
    .rotationMask {
      top: 94vh;
      height: 6rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 3;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      font-size: 1.5rem;
    }

    // swiper 轮播图
    .sAstyle {
      height: 100%;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      z-index: 1;
    }
  }
}

.footer-box {
  box-sizing: border-box;
  height: 300px;
  width: 100%;
  bottom: 0;
  z-index: 999;
}

.bodyContent {
  padding: 20px 0;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  // 山哩宣传片
  .companyPromotional {
    height: 65vh;
    width: 65%;
  }

  // 公司介绍
  .corproateCulture {
    height: 50vh;
    width: 65%;
    display: flex;

    .corproateFrame {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 65%;
      margin: 60px 20px;

      .corproateFont {
        display: flex;
        flex-direction: column;

        .corproateChildFont {
          font-weight: 550;
          font-size: 4rem;
          letter-spacing: 0.5rem;
        }

        .corproateChildFont1 {
          font-size: 2rem;
          letter-spacing: 3px;
        }
      }

      .corproateDuction {
        display: inline-block;
        font-size: 2rem;
        margin-top: 6rem;
        line-height: 3rem;
        letter-spacing: 0.2rem;

      }
    }

    .corproateFrame1 {
      margin: 50px 20px;
      width: 35%;

      .frameImg {
        height: 100%;
        width: 100%;
      }
    }
  }

  // 企业组织架构
  .enterpriseOrgan {
    box-sizing: border-box;
    width: 100%;

    .enterpriseOrganContent {
      display: flex;
      justify-content: center;
      height: 80vh;
      width: 100%;

      .enterpriseOrganContentImgFrame {
        width: 65%;
      }
    }
  }

  // 企业发展历程
  .development {
    box-sizing: border-box;
    width: 100%;

    .developmentContent {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .developmentContentChild {
        width: 65%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .developmentFrame {
          margin: 40px 0;
          display: flex;
          flex-direction: column;
          height: 350px;
          width: 42rem;
          font-size: 1.1rem;
          background-color: #CFCCCC;

          .developmentFrameImg {
            display: flex;
            justify-content: center;
            margin: 1rem 2rem;
            height: 250px;
          }

          .developmentFrameYear {
            font-size: 3rem;
            color: #7B0000;
            font-weight: bold;
            margin: 0 2rem;
            height: 50px;
            display: flex;
            align-items: center;
          }

          .developmentFrameContent {
            font-size: 16px;
            flex: 1;
            margin: 0.5rem 1.8rem;
            line-height: 2.5rem;
          }
        }
      }

      // 插入
      .insertFrame {
        height: 1920px;
        left: 25.5%;
        width: 50%;
        position: absolute;
        display: flex;
        justify-content: center;

        .insertChildFrame {
          width: 8px;
          background-color: #7B0000;
        }

        .circleGroup {
          position: relative;
          left: -15px;
          display: flex;
          flex-direction: column;

          .circle {
            width: 2.2rem;
            height: 2.2rem;
            background-color: #7B0000;
            border-radius: 20px;
            margin-top: 20rem;

            &:nth-child(n+2) {
              margin-top: 40rem;
            }
          }
        }
      }

      // 文字

      .propaganda {
        position: relative;
        width: 35%;
        bottom: 350px;
        left: 500px;


        .propagandaChild {
          width: 60%;
          height: 14rem;
          font-size: 2rem;
          font-weight: bold;

          .propagandaChild1 {
            font-size: 8rem;
          }

          .propagandaChild2 {
            font-size: 4rem;
          }

          .propagandaChild3 {
            font-size: 3rem;
          }
        }
      }


    }
  }

  // 企业文化
  .corporateCulture {
    box-sizing: border-box;
    width: 100%;

    // 内容
    .cultureContent {
      display: flex;
      flex-direction: column;
      align-items: center;

      .cultureContentFrame {
        height: 60vh;
        width: 65%;
        z-index: 4;

        .imgStyle {
          height: 100%;
          width: 100%;
        }
      }

      .cultureContent1 {
        height: 60vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;

        .cultureContent1ChildFrame {
          top: 5rem;
          position: relative;
          height: 40vh;
          width: 100%;
          padding: 0 5px;
          z-index: 3;

          .imgStyle {
            height: 100%;
            width: 100%;
            border-radius: 10px;
          }
        }

        .cultureContent1Child {
          background-color: #7B0000;
          height: 20vh;
          width: 100%;
        }
      }

      .enterpriseVision {
        top: -350px;
        position: relative;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 99;
        font-size: 25px;
      }
    }
  }

  // 企业资质
  .enterpriseQua {
    box-sizing: border-box;
    width: 100%;

    .enterpriseQuaContent {
      display: flex;
      justify-content: center;

      .enterpriseQuaContentFrame {
        padding: 20px 0;
        width: 65%;

        .enterpriseQuaContentChild {
          display: flex;
          flex-direction: column;
          height: 60vh;

          .enterpriseQuaContentFont {
            height: 5rem;
            padding: 0 1.4rem;
            display: flex;
            background-color: #7B0000;
            width: 30%;
            align-items: center;
            color: #fff;

            .enterpriseFontChild {
              font-size: 2rem;
            }

            .enterpriseFontChild1 {
              margin-left: 2rem;
              font-size: 1.2rem;
            }
          }

          .enterpriseImg {
            margin: 0.3rem 1rem;
            height: 80%;
            width: 98%;
          }
        }

        .enterpriseQuaContentChild1 {
          display: flex;
          flex-direction: column;

          .enterpriseQuaContentFont {
            height: 5rem;
            padding: 0 1.4rem;
            display: flex;
            background-color: #7B0000;
            width: 30%;
            align-items: center;
            color: #fff;

            .enterpriseFontChild {
              font-size: 2rem;
            }

            .enterpriseFontChild1 {
              margin-left: 2rem;
              font-size: 1.2rem;
            }
          }

          .enterpriseQuaContentChild1Frame {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;



            .enterpriseQuaContentChild1Img {
              margin: 0 0.5rem;
              display: flex;
              justify-content: center;
              z-index: 3;

              .enterpriseQuaChildImg1 {
                height: 100%;
                width: 64%;
              }

              .enterpriseQuaChildImg2 {
                height: 100%;
                width: 34%;
                margin-left: 2%;
              }
            }

            .enterpriseQuaChild1Bg {
              width: 100%;
              color: #fff;
              padding: 4rem 10rem 1rem 10rem;
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #7B0000;
              line-height: 2rem;
              font-size: 1.4rem;
              position: relative;
              top: -3rem;
            }
          }
        }
      }
    }
  }
}

//  顶部
.developmentTop {
  display: flex;
  justify-content: center;
  align-items: center;

  .developmentTopFrame {
    height: 4rem;
    // 宽度
    width: 40%;
    background-color: #7B0000;
  }

  .developmentTopFont {
    width: 350px;
    margin: 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #7B0000;

    .developmentFontChild {
      font-size: 3rem;
      font-weight: bolder;
    }

    .developmentFontChild1 {
      padding-bottom: 10px;
      border-bottom: 1px solid #7B0000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/group.vue